<template>
  <v-row>
    <v-col cols="16" class="d-flex align-center gap-8">
      <div class="box-logo">
        <i class="icon-SKUTRANS text-red font-24"></i>
      </div>
      <span class="font-16 font-w-500">การซื้อสินค้ารายกลุ่มสินค้า :</span>
    </v-col>
    <v-col cols="3">
      <span class="font-12 font-w-500">เงื่อนไข :</span>
      <v-select
        v-model="visitShopDetailCondition"
        :items="conditionList"
        item-value="id"
        item-text="title"
        class="v-select-custom mt-1"
        placeholder="ยอดซื้อสะสมปีปัจจุบัน"
        append-icon="mdi-chevron-down"
        solo
        flat
        dense
        hide-details
      >
        <template #item="{ item, on, attrs }">
          <v-list-item class="ma-0" v-on="on" v-bind="attrs">
            <v-list-item-title>
              <span class="font-16 font-w-400">
                {{ item.title }}
              </span>
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon
                v-if="item.id === visitShopDetailCondition"
                color="#8F0000"
              >
                mdi-check-circle
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-select>
    </v-col>
    <v-col cols="3">
      <span class="font-12 font-w-500">จัดเรียงโดย :</span>
      <v-select
        v-model="visitShopDetailSort"
        :items="sortList"
        item-value="id"
        item-text="title"
        class="v-select-custom mt-1"
        placeholder="เรียงจากมากไปน้อย"
        append-icon="mdi-chevron-down"
        solo
        flat
        dense
        hide-details
      >
        <template #item="{ item, on, attrs }">
          <v-list-item class="ma-0" v-on="on" v-bind="attrs">
            <v-list-item-title>
              <span class="font-16 font-w-400">
                {{ item.title }}
              </span>
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon v-if="item.id === visitShopDetailSort" color="#8F0000">
                mdi-check-circle
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12">
      <v-skeleton-loader
        v-if="visitShopDetailDetailListLoad"
        type="list-item-three-line, list-item-three-line"
      ></v-skeleton-loader>

      <div
        v-else-if="
          visitShopDetailDetailListLoad === false && detailList.length === 0
        "
        class="text-center py-10"
      >
        <span>ไม่มีข้อมูล</span>
      </div>

      <div v-else class="table-custom">
        <div class="table-custom--header">
          <section style="height: 200px" class="table-custom--header-box">
            <div style="flex: 1" class="d-flex align-end">รายละเอียด</div>
            <div style="flex: 1" class="d-flex justify-end">กลุ่มสินค้า</div>
          </section>
          <section
            style="width: 185px; height: 50px"
            class="d-flex align-center px-3"
          >
            <span>1. มียอดซื้อใน 1 เดือน</span>
          </section>
          <section
            style="width: 185px; height: 50px; background: #f4f4f4"
            class="d-flex align-center px-3"
          >
            <span>2. วันที่สั่งซื้อล่าสุด</span>
          </section>
          <section
            style="width: 185px; height: 50px"
            class="d-flex flex-column justify-center px-3"
          >
            <span>3. ยอดซื้อสะสมปีปัจจุบัน (บาท)</span>
            <span class="font-10" style="margin-left: 13px">
              ({{
                (Array.isArray(detailList) && detailList[0].date_ty) || ' - '
              }})
            </span>
          </section>
          <section
            style="width: 185px; height: 50px; background: #f4f4f4"
            class="d-flex flex-column justify-center px-3"
          >
            <span>4. ยอดซื้อสะสมปีที่แล้ว (บาท)</span>
            <span class="font-10" style="margin-left: 13px">
              ({{
                (Array.isArray(detailList) && detailList[0].date_ly) || ' - '
              }})
            </span>
          </section>
          <section
            style="width: 185px; height: 50px"
            class="d-flex flex-column justify-center px-3"
          >
            <span>5. ยอดซื้อสะสมเทียบปี (บาท)</span>
            <span class="font-10" style="margin-left: 13px">
              ({{
                (Array.isArray(detailList) && detailList[0].date_month) ||
                ' - '
              }})
            </span>
          </section>
          <section
            style="width: 185px; height: 50px; background: #f4f4f4"
            class="d-flex align-center px-3"
          >
            <span>6. อัตราการเติบโต (%)</span>
          </section>
        </div>

        <div style="overflow-x: auto">
          <div class="table-custom--body">
            <div v-for="(item, index) in detailList" :key="index">
              <head
                style="width: 82px; height: 200px"
                class="table-custom--body-label"
              >
                <span>{{ item.product_group }}</span>
              </head>
              <section style="width: 82px; height: 50px">
                <v-icon v-if="item.coverage === '1'" size="62" color="#4A90E2">
                  mdi-circle-small
                </v-icon>
                <v-icon v-else size="62" color="#C4C4C4">
                  mdi-circle-small
                </v-icon>
              </section>
              <section style="width: 82px; height: 50px; background: #f4f4f4">
                <span>{{ item.max_doc_date || '-' }}</span>
              </section>
              <section style="width: 82px; height: 50px">
                <span>{{ formatNumber(item.sum_amount_ty) }}</span>
              </section>
              <section style="width: 82px; height: 50px; background: #f4f4f4">
                <span>{{ formatNumber(item.sum_amount_ly) }}</span>
              </section>
              <section style="width: 82px; height: 50px">
                <span v-if="checkNumber(item.diff_yoy) === -1" class="text-red">
                  {{ formatNumber(item.diff_yoy) }}
                </span>
                <span
                  v-if="checkNumber(item.diff_yoy) === 1"
                  class="text-green"
                >
                  +{{ formatNumber(item.diff_yoy) }}
                </span>
                <span v-if="checkNumber(item.diff_yoy) === 0" class="font-grey">
                  0
                </span>
              </section>
              <section style="width: 82px; height: 50px; background: #f4f4f4">
                <span v-if="checkNumber(item.gr_yoy) === -1" class="text-red">
                  {{ formatNumber(item.gr_yoy) }}%
                </span>
                <span v-if="checkNumber(item.gr_yoy) === 1" class="text-green">
                  +{{ formatNumber(item.gr_yoy) }}%
                </span>
                <span v-if="checkNumber(item.gr_yoy) === 0" class="font-grey">
                  0
                </span>
              </section>
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import numeral from 'numeral'

export default {
  props: {
    ScgBPNumber: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      conditionList: [
        { id: 1, title: 'ยอดซื้อสะสมปีปัจจุบัน' },
        { id: 2, title: 'ยอดซื้อสะสมเทียบปี' },
        { id: 3, title: 'อัตราการเติบโต' },
      ],
      sortList: [
        { id: 'DESC', title: 'เรียงจากมากไปน้อย' },
        { id: 'ASC', title: 'เรียงจากน้อยไปมาก' },
      ],
    }
  },
  computed: {
    detailList() {
      return this.$store.state.visitShopDetail.detailList
    },
    visitShopDetailCondition: {
      get() {
        return this.$store.state.visitShopDetail.condition
      },
      set(value) {
        this.$store.commit('visitShopDetail/conditionUpdate', value)
      },
    },

    visitShopDetailSort: {
      get() {
        return this.$store.state.visitShopDetail.sort
      },
      set(value) {
        this.$store.commit('visitShopDetail/sortUpdate', value)
      },
    },

    visitShopDetailDetailListLoad: {
      get() {
        return this.$store.state.visitShopDetail.detailListLoad
      },
      set(value) {
        this.$store.commit('visitShopDetail/detailListLoadUpdate', value)
      },
    },
  },

  methods: {
    formatNumber(value) {
      if (Number(value) === 0) {
        return '0'
      }
      return numeral(value).format('0,0')
    },
    checkNumber(value) {
      const sign = Math.sign(value)
      return sign
    },
    async getDashboardBTAnalyticBT() {
      try {
        this.detailListLoad = true
        const res = await this.$axios.post(
          `${this.$baseAPI}/visit/getdashboardBTAnalyticBT`,
          {
            scg_bp_number: this.ScgBPNumber,
            condition: this.condition, //1,2,3 ตามลำดับ
            sort: this.sort, // DESC,ASC
          },
          {
            headers: this.setheaders,
          },
        )
        this.detailList = res.data.detail
      } catch (error) {
        console.error(error)
        this.detailList = []
      } finally {
        this.detailListLoad = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.box-logo {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #faf3f4;
}

.table-custom {
  display: flex;
  justify-content: center;

  &--header {
    font-size: 12px;
    font-weight: 500;
  }

  &--header-box {
    background: linear-gradient(
      to top right,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0) calc(50% - 1px),
      rgb(255, 255, 255) 50%,
      rgba(255, 255, 255, 0) calc(50% + 1px),
      rgba(255, 255, 255, 0) 100%
    );
    background-color: #606060;
    border-right: 1px solid #fff;
    color: #fff;
    display: flex;
    padding: 2rem;
  }

  &--body {
    display: flex;
    font-size: 12px;
    font-weight: 500;

    div > head {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    div > section {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
    }
  }

  &--body-label {
    background-color: #606060;
    color: #fff;
    border-left: 1px solid #fff;
    writing-mode: tb-rl;
    transform: rotate(-180deg);
  }
}
</style>
